import {initializeApp, getApps} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getFirestore, connectFirestoreEmulator} from 'firebase/firestore';
import {getAuth, connectAuthEmulator} from "firebase/auth";
import {getFunctions, connectFunctionsEmulator} from 'firebase/functions';
import {getStorage, connectStorageEmulator} from "firebase/storage";
import {config} from "./config";

function initializeServices() {
    const isConfigured = getApps().length > 0;
    const firebaseApp = initializeApp(config.firebase);
    const firestore = getFirestore(firebaseApp);
    const auth = getAuth(firebaseApp);
    const functions = getFunctions(firebaseApp);
    const storage = getStorage(firebaseApp);
    const analytics = getAnalytics(firebaseApp);
    return {firebaseApp, auth, firestore, functions, storage, analytics, isConfigured}
}

function connectToEmulators({auth, firestore, functions, storage}) {
    if (window.location.hostname === 'localhost') {
        connectAuthEmulator(auth, "http://localhost:9099");
        connectFirestoreEmulator(firestore, "localhost", 8090);
        connectFunctionsEmulator(functions, "localhost", 5001);
        connectStorageEmulator(storage, "localhost", 9199);
    }
}


export function getFirebase() {
    const services = initializeServices();
    if (!services.isConfigured) {
        connectToEmulators(services);
    }
    return services;
}

// export const fbApp = initializeApp(firebaseConfig);
// export const fbAuth = getAuth(fbApp);
// export const fbFirestore = getFirestore(fbApp);
// export const analytics = getAnalytics(fbApp);
// export const fbFunctions = getFunctions(fbApp);
// export const fbStorage = getStorage(fbApp);
